<h3 trans>Fonts</h3>

<div class="material-panel">
  <google-font-selector [formControl]="editor.appearanceForm.get('fontConfig')"></google-font-selector>
</div>
